import Fuse from 'fuse.js';
export default {
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      } else {
        if (this.searchQuery) {
          result = []
        }
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [ 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      searchedData: [],
      fuseSearch: null
    }
  },
  methods: {
    sortChange({ prop, order }) {
      const sortFn = (a, b) => {
        if (!prop) {
          return a.id - b.id
        }
        let aVal = a[prop]
        let bVal = b[prop]
        // Handle numeric comparison
        if (typeof aVal === 'number' && typeof bVal === 'number') {
          return order === 'ascending' ? aVal - bVal : bVal - aVal
        }
        // Handle string comparison
        if (aVal == null) aVal = ''
        if (bVal == null) bVal = ''
        if (order === 'ascending') {
          return aVal > bVal ? 1 : aVal < bVal ? -1 : 0
        }
        return aVal < bVal ? 1 : aVal > bVal ? -1 : 0
      }
      // Sort both tableData and searchedData
      this.tableData.sort(sortFn)
      if (this.searchedData.length > 0) {
        this.searchedData.sort(sortFn)
      }
    },
	initSearch(data){
		this.searchedData = data
		this.fuseSearch = new Fuse(data, {
		  keys: this.propsToSearch,
		  threshold: 0.05
		});
  
		if (this.searchQuery !== ''){
		  this.searchedData = this.fuseSearch.search(this.searchQuery);
		}
	  }
  },
  mounted() {
    this.initSearch(this.tableData)
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },

	tableData(value){
		this.initSearch(this.tableData)
	}
  }
}
